import styled from "styled-components";

import mayoLogo from "../../../../assets/Logos/mayo-clinic-logo1.svg";
import gistmdLogo from "../../../../assets/Logos/gist_logo.svg";

export default function MayoLogo({style}) {
  return (
    <LogoHeader style={style}>
      <LeftLogo
        src={mayoLogo}
      />
      <RightLogo
        src={gistmdLogo}
        height={26.56}
      />
    </LogoHeader>
  );
}

const LogoHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-top: 20px;
`

const LeftLogo = styled.img`
  margin-left: 15px;
  width: 50px;
`

const RightLogo = styled.img`
  margin-right: 19px;
  margin-left: auto;
`
